export const selectIsUserDataFetching = (state) => state.loyaltyCore.isUserDataFetching;
//# sourceMappingURL=selectIsUserDataFetching.js.map